
import React, { useEffect, useState } from 'react';
import { Table, Modal as AntdModal } from 'antd';
import { pinnedHistory } from '@services/productService';
import { getBrandRecord } from '@services/brandService';
import bxlutils from 'bxl-utils';
import { PAPYRUS_ORIGIN } from '../../common/constants';

function isBase64(str) {
  if (str === '' || str.trim() === '') {
      return false;
  }
  try {
      return btoa(atob(str)) == str;
  } catch (err) {
      return false;
  }
}

function PinnedHistoryModal(props) {
  const { productId, type, visible, onClose } = props;
  const [dataSource, setDataSource] = useState([]);

  const columns = [
      {
          title: '操作人',
          dataIndex: 'editor',
          key: 'editor',
          width: '25%',
          render: (row) => {
              return <a href={`${PAPYRUS_ORIGIN}/#/userlookup/${row}`} target="_blank">{row}</a>
          }
      },
      {
          title: '操作时间',
          dataIndex: 'time',
          key: 'time',
          width: '25%'
      },
      {
          title: '改前分类',
          dataIndex: 'oldCategoryIds',
          key: 'oldCategoryIds',
          width: '25%'
      },
      {
          title: '改后分类',
          dataIndex: 'categoryIds',
          key: 'categoryIds',
          width: '25%'
      }
  ];
  const brandColumns = [
    {
      title: '操作人',
      dataIndex: 'editor',
      key: 'editor',
      width: '25%',
      render: (row) => {
        return <a href={`${PAPYRUS_ORIGIN}/#/userlookup/${row}`} target="_blank">{row}</a>
      }
    },
    {
      title: '操作时间',
      dataIndex: 'time',
      key: 'time',
      width: '25%'
    },
    {
      title: '改前品牌',
      dataIndex: 'oldBrandName',
      key: 'oldBrandName',
      width: '25%'
    },
    {
      title: '改后品牌',
      dataIndex: 'brandName',
      key: 'brandName',
      width: '25%'
    }
  ];

  useEffect(() => {
      if (type && type === 'category') {
          pinnedHistory(productId)
            .then((res) => {
                setDataSource(formatData(res.data));
            }).catch((err) => {
            })
      } else if(type && type === 'brand') {
        getBrandRecord(productId)
        .then((res) => {
            setDataSource(formatData(res.data));
        }).catch((err) => {
        })
      }
  }, [type, productId]);

  function formatData(data) {
      const newData = data?.map((item, index) => {
          let content: any = {};
          if(item.content) {
              if(isBase64(item.content)) {
                  content = JSON.parse(bxlutils.uri.decodeBase64(item.content) || item.content || '{}');
              } else {
                  content = JSON.parse(item.content || '{}');
              }
          }
          if (type === 'category') return {
              key: index,
              editor: content.record.editor,
              time: bxlutils.formatter.format(content.timestamp, 'YYYY-MM-DD HH:mm:ss'),
              oldCategoryIds: content.record.oldCategoryIds.join(','),
              categoryIds: content.record.categoryIds.join(',')
          }
          if (type === 'brand') return {
              key: index,
              editor: content.record.editor,
              time: bxlutils.formatter.format(content.timestamp, 'YYYY-MM-DD HH:mm:ss'),
              oldBrandName: content.record.oldBrandName.join(','),
              brandName: content.record.brandName.join(',')
          }
      })
      return newData;
  }

  return (
      <AntdModal
        title={`${type === 'category' ? '分类' : '品牌'}修改记录`}
        visible={visible}
        width='60%'
        footer={null}
        onCancel={onClose}
      >
        <Table columns={type === 'category' ? columns : brandColumns} dataSource={dataSource} pagination={false} />
      </AntdModal>
  )
}

export default PinnedHistoryModal
